import React from 'react';
import { sanitizeCalculToString } from '../../../../../helpers/number/sanitizeCalul';
import { ProductTypes } from '../../../../../types/product/product';
import { CarouselTags } from 'components/molecules/Carousel/CarouselTags';
import { CarouselTag } from 'components/molecules/Carousel/CarouselTag';
import useStyle from './productCardBody.style';

export interface ProductCardMosaicBodyProps {
  product: ProductTypes;
  onClick: () => void;
  isPublicShop?: boolean;
}

const ProductCardBody = ({
  product,
  onClick,
  isPublicShop = false
}: ProductCardMosaicBodyProps) => {
  const classes = useStyle();
  const catProduct = product.categorieproduits;

  return (
    <div>
      {catProduct.length === 1 && <CarouselTag tag={catProduct[0]} />}
      {catProduct.length > 1 && <CarouselTags tags={catProduct} />}
      <div className={classes.description}>
        <h2 className={classes.onClick} onClick={onClick}>
          {product.ref} - {product.name}
        </h2>
        <p>
          {sanitizeCalculToString(product.ttcPrice)}€ TTC - Poids net{' '}
          {product.netWeight} g
        </p>
        {isPublicShop && (
          <p className={classes.catchPhrase}>
            {product.catchPhrase && product.catchPhrase}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductCardBody;
